import React from 'react';
import {Box, Typography, Button, Container} from '@mui/material';
import { useNavigate } from "react-router-dom";
import {auth} from '../../firebase'; // Firebase 초기화 파일 경로
import {GoogleAuthProvider, signInWithPopup} from 'firebase/auth'

const GoogleLoginPage = () => {
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      alert('Google 계정으로 로그인되었습니다.');
      navigate('/trade'); // 로그인 성공 시 /trade 페이지로 이동
    } catch (error) {
      console.error('Error signing in with Google:', error.message);
      alert('Google 로그인에 실패하였습니다. 다시 시도해주세요.');
    }
  };

  const handleSignUpClick = () => {
    // 회원가입 페이지로 이동
    navigate('/signup');
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{mt: 8, textAlign: 'center'}}>
        <Typography variant="h4" gutterBottom>
          Google 로그인
        </Typography>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleGoogleSignIn}
        >
          Google 계정으로 로그인
        </Button>
        <Typography sx={{mt: 2}}>
          아직 회원이 아니신가요?{' '}
          <Button onClick={handleSignUpClick} color="primary">
            여기에서 회원가입
          </Button>
        </Typography>
      </Box>
    </Container>
  );
};

export default GoogleLoginPage;
